__turbopack_context__.v({
  "bottomInner": "Footer-module__S6Hkya__bottomInner",
  "bottomLink": "Footer-module__S6Hkya__bottomLink",
  "bottomLinks": "Footer-module__S6Hkya__bottomLinks",
  "colLink": "Footer-module__S6Hkya__colLink",
  "colLinks": "Footer-module__S6Hkya__colLinks",
  "colTitle": "Footer-module__S6Hkya__colTitle",
  "companyCol": "Footer-module__S6Hkya__companyCol",
  "companyDesc": "Footer-module__S6Hkya__companyDesc",
  "copyright": "Footer-module__S6Hkya__copyright",
  "footer": "Footer-module__S6Hkya__footer",
  "footerBottom": "Footer-module__S6Hkya__footerBottom",
  "footerGrid": "Footer-module__S6Hkya__footerGrid",
  "footerLogo": "Footer-module__S6Hkya__footerLogo",
  "footerLogoImage": "Footer-module__S6Hkya__footerLogoImage",
  "footerLogoText": "Footer-module__S6Hkya__footerLogoText",
  "footerTop": "Footer-module__S6Hkya__footerTop",
  "newsletter": "Footer-module__S6Hkya__newsletter",
  "newsletterBtn": "Footer-module__S6Hkya__newsletterBtn",
  "newsletterDesc": "Footer-module__S6Hkya__newsletterDesc",
  "newsletterForm": "Footer-module__S6Hkya__newsletterForm",
  "newsletterInput": "Footer-module__S6Hkya__newsletterInput",
  "socialLink": "Footer-module__S6Hkya__socialLink",
  "socials": "Footer-module__S6Hkya__socials",
});
